// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3QB35","validationTips":"StatementDescriptor_validationTips__3iagu"};